module.exports = __webpack_public_path__ + "img/address.1ab7707e.svg";